


























import { Component, Vue } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import Observer from "@/components/englishjanala/Observer.vue";
import PermittedUserList from "@/components/cards/PermittedUserList.vue";
import axios from "axios";
import Spiner from "@/components/englishjanala/Spiner.vue";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {
    sidebar,
    Observer,
    PermittedUserList,

    Spiner,
  },
})
export default class Reports extends Vue {
  Spiner: boolean = true;
  LevelId: any;
  limit: number = 20;
  wordLevel: any;
  searchResult: any;
  users: any = "";
  offset: number = 0;
  search = "";
  infiniteReport: any = [];
  componentKey = 0;

  async mounted() {
    const PassData = { offset: this.offset, limit: this.limit };
    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/GetPermittedUserList",
      PassData
    );

    this.users = response.data.emailList;
    console.warn("emailList", this.users.emailList);
    // this.infiniteReport = [...this.infiniteReport, ...response.data.words];
  }

  async intersected() {
    const PassData = { offset: this.offset, limit: this.limit };
    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/GetReportList",
      PassData
    );
    this.offset = this.offset + this.limit;

    // this.words = response.data.words;
    console.log("words 1", response.data.reports);
    this.infiniteReport = [...this.infiniteReport, ...response.data.reports];
    console.log("words ofs", this.infiniteReport);
    this.Spiner = false;
  }

  get reportList() {
    const PassData = { offset: this.offset, limit: this.limit };
    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/GetReportList",
        PassData
      )
      .then((response) => (this.searchResult = response.data.reports));

    this.componentKey++; // re-render component
    if (this.search == "") return this.infiniteReport;
    return this.searchResult;
  }
}
